"use strict";
var WebSocketStream = require("websocket-stream/stream");
var Client = require("mqtt/lib/client");

function connect(url, options){
	var builder = makeBuilder(url);
	return new Client(builder, options);
}

function makeBuilder(url) {
	var subProtocols = ["mqttv3.1"];
	return function(){
		return new WebSocketStream(url, subProtocols);
	};
}

module.exports = {
	connect: connect
};
